{
  "schemaVersion": 1,
  "locales": {
    "zh-CN": {
      "awakeners": {
        "awakener-0001": {
          "name": "「24」",
          "description": "独处时，更要学会作为团队行动。二十四个意识挤在「24」的灵魂中，于黑暗里低语嬉笑，仿佛随时准备将她吞噬；她早已告别东区工人的平凡过去，却又踏入新的泥沼。"
        },
        "awakener-0002": {
          "name": "阿格里帕",
          "description": "历史的烈火吞没一切之前，阿格里帕曾是卡普亚最耀眼的明珠。她任性而凌厉，以鞭笞掩饰脆弱，却在训练角斗士时展现出令人意外的耐心与才能。"
        },
        "awakener-0003": {
          "name": "艾继丝",
          "description": "不要靠近、触碰、直视或怜悯艾继丝。有些存在注定只能栖居黑暗；即使她并无恶意，对那双眼睛投以温柔，也可能让注视者付出无法挽回的代价。"
        },
        "awakener-0004": {
          "name": "艾尔瓦",
          "description": "艾尔瓦十分满意自己的义肢，它让她得以再次为正义而战。至于深夜宿舍里传来的低吟，以及那条手臂真正隐藏的秘密，最好假装从未听见。"
        },
        "awakener-0005": {
          "name": "奥瑞塔",
          "description": "曾在孤独中迎来死亡的海洋精灵，于陆地获得了奇迹般的新生。奥瑞塔天真乐观的魅力让人无法抗拒，也许那正是她从苦难中选择遗忘后的礼物。"
        },
        "awakener-0006": {
          "name": "凯刻斯",
          "description": "凯刻斯总阴沉地徘徊在湖畔，学生们于是把那里称作「忧郁半鱼人的领地」。他每日像领主般巡视水域，却很少有人知道湖面之下真正牵动他的是什么。"
        },
        "awakener-0007": {
          "name": "卡茜亚",
          "description": "来跳舞吧，欢快地、疯狂地跳，直到气氛沸腾。聚光灯下，疯癫的魔术师卡茜亚已经把手伸进帽中，而下一幕取出的东西未必适合观众观看。"
        },
        "awakener-0008": {
          "name": "卡斯托尔",
          "description": "若生在普通家庭，卡斯托尔本可成长为温厚可靠的青年。如今双子中只有他保有完整的身体与灵魂，他像石头般沉默，把两人共有的余烬深埋心中，等待牢笼开启的一刻。"
        },
        "awakener-0009": {
          "name": "希莱斯特",
          "description": "希莱斯特空灵的美总让人想起飞向理想乡的天堂鸟。白裙随风轻扬，而栖在桅杆上的少女是否也曾幻想，自己终有一天能真正飞入碧空？"
        },
        "awakener-0010": {
          "name": "克莱门汀",
          "description": "人人都戴着不同的人格面具，克莱门汀选择了最能麻痹人心的一张。她温柔的笑容和话语让来访者相信遇见了救赎，却很少有人能窥见面具后真正的她。"
        },
        "awakener-0011": {
          "name": "克珀珊特",
          "description": "克珀珊特既是高扬的旗帜，也是船沉没前坚守到最后的挽歌。责任、使命与生命都系于那艘船上；航向何处并不重要，重要的是她永远不会离开。"
        },
        "awakener-0012": {
          "name": "达芙黛尔",
          "description": "欢迎来到达芙黛尔女士的交换所：以物易物，也收购人头，童叟无欺。灰雾与烟斗之后，她以优雅笑容经营着一门危险而绝对公平的生意。"
        },
        "awakener-0013": {
          "name": "朵尔",
          "description": "烧过的实验台要擦亮，量具每三天必须校准，所有器皿都要焕然如新。朵尔对科学与世界奥秘的狂热，使她对实验室中的每个人和每件物品都抱有近乎苛刻的标准。"
        },
        "awakener-0014": {
          "name": "杜勒赛因",
          "description": "杜勒赛因是亡灵之都的缔造者，也是食尸鬼永恒的王。他的宴会盛大、优雅而令人期待，只是那些以尸骸精心烹制的菜肴，足以让来客终生难忘。"
        },
        "awakener-0015": {
          "name": "艾瑞卡",
          "description": "朵尔检查过艾瑞卡的每一处身体结构，却找不到任何能让她发声的部件。她如何说话至今仍是密大谜团之一，而偶尔从她体内传出的陌生声音，更让答案显得危险。"
        },
        "awakener-0016": {
          "name": "菲茵特",
          "description": "菲茵特是一颗褪色而难以孵化的种子。人们因她的缺陷而怜惜她、因她的脆弱而爱她；但知道她是自愿留在壳中的人，早已化作星尘。"
        },
        "awakener-0017": {
          "name": "法洛思",
          "description": "法洛思冷静理性的言语下潜伏着海妖般的诱惑。不要探究畸形头盔下的模样，也别忘记她对这具人形躯体长久的不满；那道幽光从来不是为了照亮归途。"
        },
        "awakener-0018": {
          "name": "熔毁·朵尔",
          "description": "天才与疯狂只隔一线。曾经最耀眼的密大学者在理性废墟中化作熔毁·朵尔，她仍披着科学的外衣，却把生命、伦理与常识一并投入疯狂实验。"
        },
        "awakener-0019": {
          "name": "血链·希洛",
          "description": "自踏入监狱起，血链·希洛的记忆便被鲜血浸透。温暖的往昔碎裂成扎入血肉的尖片，她已记不起温柔，只记得锁链、背叛，以及绝不能熄灭的复仇。"
        },
        "awakener-0020": {
          "name": "环行·拉蒙娜",
          "description": "环行·拉蒙娜计算剑速、闪避角度、逃脱概率，也计算世界走向未来的可能。直到最后一刻她都没有停止演算，正如她从未停止沿着时间向前行走。"
        },
        "awakener-0021": {
          "name": "戈利亚",
          "description": "戈利亚只是一个巨人：身影令人敬畏，力量不可撼动，巨刃无人能举。他以战争与牺牲磨亮胜利，也在一座座战利品堆成的山上证明强者的法则。"
        },
        "awakener-0022": {
          "name": "哈姆林",
          "description": "哈姆林像一件洁白奢华的东方瓷器，优雅、细腻，却触手冰冷。端正外表下是一颗纯净到空洞的灵魂，他的一生只有一条指令：演奏，永不停歇地演奏。"
        },
        "awakener-0023": {
          "name": "希洛",
          "description": "希洛并非生来嗜血。短暂的温暖被背叛与囚禁夺走，反抗化作复仇之火烧遍故土；在无尽怨恨中，她只剩下挣脱锁链和讨回血债的意志。"
        },
        "awakener-0024": {
          "name": "奥尔拉",
          "description": "玫瑰尖刺穿透诗页，留下透明血迹；酒香弥漫，无色火焰四处蔓延。奥尔拉在烈焰中握着最后一首诗，为那位被埋没的天才诗人写下终章。"
        },
        "awakener-0025": {
          "name": "詹金",
          "description": "有詹金的地方就有布朗，有布朗单独行动的地方，背后也一定藏着詹金。她总能一脸无辜地拿出不在场证明，哪怕失物此刻就在布朗怀里。"
        },
        "awakener-0026": {
          "name": "珈伦",
          "description": "珈伦想戴上酒色般深邃的紫晶，穿鸵鸟羽制成的华服，成为宴会唯一的光。她仍有无数美丽愿望，只是那位眨着琥珀色眼睛的女仆，已经再也无法亲口说出它们。"
        },
        "awakener-0027": {
          "name": "凯蒂古拉",
          "description": "凯蒂古拉擅长用招牌笑容唤醒旁观者心底最残酷的寒意。双枪与火药只是她打发无聊的玩具；当她真正开火时，枪膛里甚至不需要装入子弹。"
        },
        "awakener-0028": {
          "name": "雷娅",
          "description": "嘘，别怕，那只是湿冷地窖里老鼠腐烂的声音。雷娅灵魂深处囚禁着猩红欲望，如盲者渴望光、饥者渴望血；满足它的代价，往往也是鲜血。"
        },
        "awakener-0029": {
          "name": "莉莉",
          "description": "莉莉渴望着她称作「妈妈」的存在，并顺从「主人」的一切命令。真实姓名早已遗失，她如今只以这具躯体的形态为名——一朵在腐败中心绽放的白色百合。"
        },
        "awakener-0030": {
          "name": "莉兹",
          "description": "莉兹在幽绿火焰中起舞，虔诚的年轻面孔被微光照亮。每一次旋转都点燃罪人的灵魂，让舞台上的污秽在翡翠色烈焰中烧尽。"
        },
        "awakener-0031": {
          "name": "萝坦",
          "description": "萝坦身上的标签多得让人不知如何相处：谦卑会令她无聊，傲慢会招来巨剑，强硬或软弱也都有代价。最安全的办法，也许是用一场足够痛快的战斗向她打招呼。"
        },
        "awakener-0032": {
          "name": "弥利亚姆",
          "description": "黑袍遮住弥利亚姆瘦削的身体，她沉默而虔诚，像壁画中哀恸的圣母。她把全部存在都投入漫长等待，只为迎接那个足以终结信仰、也完成信仰的时刻。"
        },
        "awakener-0033": {
          "name": "茉夏",
          "description": "严格来说，茉夏并不属于这个濒临崩溃的世界，但她欣赏它燃烧的壮景，也欣赏绝望中的痛苦与瓦解。信仰已死，而她把末日当成一场值得喝彩的演出。"
        },
        "awakener-0034": {
          "name": "墨菲",
          "description": "骄傲、任性、自我中心——认识墨菲的人常这样评价她。她似乎一直被当作世界的中心精心照料，也因此把宠爱视为理所当然，把他人的边界视为可以随意越过的装饰。"
        },
        "awakener-0035": {
          "name": "诞妄·墨菲",
          "description": "诞妄·墨菲傲慢地自称「神母」，冷漠而敌视地把所有人挡在安全范围外。人们很难把她与从前娇纵的小公主联系起来，但那份以自我为中心的本质从未真正改变。"
        },
        "awakener-0036": {
          "name": "诺缔拉",
          "description": "诺缔拉总绕着名为「幻影」的摩托忙碌：拧紧螺丝、调整管线，永远没有完工的一天。别人认为修理早已完美，她却仍日复一日投入其中，仿佛停下才会失去方向。"
        },
        "awakener-0037": {
          "name": "宁菲亚",
          "description": "宁菲亚的投影仍保持着早逝少女的模样。破旧衣裙、苍白肌肤与沉在眼底的阴影，无声讲述着一段被疾病和苦难紧紧缠绕的过去。"
        },
        "awakener-0038": {
          "name": "奥吉尔",
          "description": "奥吉尔的一言一行都体现忠诚与美德，克己守礼仿佛刻进灵魂。只是这位完美骑士仍保留着孩子的外貌，也请不要因此轻视他挥枪守护信念的决心。"
        },
        "awakener-0039": {
          "name": "潘狄娅",
          "description": "清脆甜美的笑声在烛影中回荡，潘狄娅娇小的身影随之出现。她既是罪人的恐惧也是欲望，为濒死者带来甜蜜痛楚与浪漫疯狂，长鞭的脆响便是她的邀请。"
        },
        "awakener-0040": {
          "name": "皮克曼",
          "description": "皮克曼是半人半食尸鬼的艺术家，拥有凡人无法企及的异质天赋。他的画作会溶解画中世界与现实的边界，把观众拖入完整、逼真而往往恐怖的景象。"
        },
        "awakener-0041": {
          "name": "波吕克斯",
          "description": "波吕克斯是由割裂皮肤、空洞胸腔、污浊心脏与无形锁链缝合出的扭曲血肉。他被供上神坛、被称作纯洁灵魂，却始终在无数梦境中追问：自己究竟是什么？"
        },
        "awakener-0042": {
          "name": "拉蒙娜",
          "description": "拉蒙娜的档案多次被移交学生管理部门，又总被她亲手送回并埋进文件山。「先放在这里，迟早还会送来。」她平静地说，仿佛早已算见一切循环。"
        },
        "awakener-0043": {
          "name": "莱克",
          "description": "莱克被同行称作「幸运侦探」：下注总能翻倍，猜测总会命中。极端好运让他无需依靠常规推理，却也使人怀疑，那究竟是天赋、诅咒，还是某种更危险的安排。"
        },
        "awakener-0044": {
          "name": "萨尔瓦多",
          "description": "不必畏惧萨尔瓦多的黑色眼罩，窒息般的黑暗遮不住他的慈悲。肉身的视线或许已死，救赎的意志却依然存在；在他面前，一切都应当被爱，也终将得到爱。"
        },
        "awakener-0045": {
          "name": "珊",
          "description": "来自希特的艺术家珊漠视旁人，只追求绝对而纯粹的美。灵感奔涌时凿刀永不停歇，她把转瞬即逝的瞬间刻成永恒，也让自己的身体逐渐沉入创作的代价。"
        },
        "awakener-0046": {
          "name": "索蕾尔",
          "description": "索蕾尔的巧舌如玫瑰花蜜，贵族与廷臣则是围绕花朵起舞的蜂蝶。欲望滋养的荆棘早已缠上花窗；流言越盛，她越能微笑着把每个人引向自己布置的舞台。"
        },
        "awakener-0047": {
          "name": "塔薇",
          "description": "塔薇不存在于当前世界，因为其存在会招来「至高意志」的注视。守门人能给予求知者的只有智慧与沉默，而在漫长守望中，祂静静注视无数人来到门前又离去。"
        },
        "awakener-0048": {
          "name": "泰旖丝",
          "description": "珠宝与轻纱掩住泰旖丝真正的模样，惊艳奢华只是她精心选择的外壳。许多人以为她虚荣轻浮，但那也许只是另一张面具，用来遮住无人能够触及的内心。"
        },
        "awakener-0049": {
          "name": "汀克特",
          "description": "汀克特是群星间的歌者、闪烁的星尘，也是困在金笼中的鸟与被遗弃的留声机。故乡坠入虚空后，她被迫拥抱生存的希望，成为无主深空中的流浪者。"
        },
        "awakener-0050": {
          "name": "图鲁",
          "description": "年轻的王沉睡于王座，醒来便颁下传遍世界的敕令。可太阳尚未落山，图鲁已经厌倦权力、超凡智慧与臣民狂热的膜拜，只想从神王身份中得到片刻安静。"
        },
        "awakener-0051": {
          "name": "尤乌哈希",
          "description": "谁会忘记英雄尤乌哈希？战士跪倒在夕阳染红的沙地，温热鲜血浸透身体，秃鹫在头顶盘旋唱起挽歌。英雄之名被永远记住，代价却是无人替他流泪。"
        },
        "awakener-0052": {
          "name": "旺达",
          "description": "旺达聪明、富有而美丽，并宣称自己只为享乐而活。她让男人俯首成奴，把冰冷双足踏上他们的背；这位戴冠的维纳斯既是邪恶化身，也是梦境本身。"
        },
        "awakener-0053": {
          "name": "温柯尔",
          "description": "温柯尔的办公室被称作密大的北极星，灯笼、油灯、钨丝灯与蜡烛驱散每一寸阴影。她对黑暗的恐惧近乎偏执，却也让那间永不熄灯的房间成为迷途者的坐标。"
        },
        "awakener-0054": {
          "name": "徐",
          "description": "优雅而魅惑的东方「神明」徐拥有致命吸引力。传说她放下折扇时，人会在扇后看见挚爱之脸；更应祈祷她永远别注视你，否则她会像夜雾般渗入记忆，只留下空洞痴迷。"
        },
        "awakener-0055": {
          "name": "莫丝",
          "description": "语言不通可以用手势，力量失控在这所学校也算寻常。莫丝凭灿烂笑容和近乎野性的直率迅速融入校园，只是她表达友好的方式，往往伴随着过于惊人的破坏力。"
        },
        "awakener-0056": {
          "name": "阿拉克涅",
          "description": "阿拉克涅是被自身蛛网困住的织者，也是命运剧场的编剧与永恒观众。丝线从指尖化作幕布、剧本与牢笼，最终将她裹进无法逃脱的茧，让独角戏永无落幕。"
        },
        "awakener-0057": {
          "name": "沙耶",
          "description": "当扭曲血肉侵蚀万物、日常彻底颠覆，一朵蒲公英伴着哀鸣落在荒原。伸出手握住沙耶吧；爱会穿透表象，把你牢牢系在所爱之人身旁。"
        },
        "awakener-0058": {
          "name": "蓬托斯",
          "description": "本该划过夜空的英雄史诗在途中折断。蓬托斯选择坠入深渊，将自己献给更庞大而不可理解的存在，从此把亲族、朋友与敌人都永远留在与自身融合的埃布维诺斯之中。"
        },
        "awakener-0059": {
          "name": "鲸皇·萝坦",
          "description": "无论身处哪个维度，萝坦都不爱言语，鲸皇·萝坦更是如此；力量就是她唯一的雄辩。王者般从容之下燃烧着对强敌的饥渴，鲸骨双刃也与她一样，永远渴望更高的巅峰。"
        },
        "awakener-0060": {
          "name": "卡拉布",
          "description": "她就像最早熟的孩子，总能察觉你内心深处的想法，不断诱导你交付信任、吐露秘密，再于恰到好处的时机献上你渴望已久的“祝福”。\n但请牢记：绝不可因她娇小的身形与惹人怜爱的眼神心生恻隐，否则，你也将成为那纯白之躯所吞噬的又一个贪婪灵魂。"
        },
        "awakener-0061": {
          "name": "负誓·奥吉尔",
          "description": "虽然外形相同，但这个少年与人们熟悉的小骑士显然判若两人。\n他眼中的光芒已经消逝，白衣也沾染了污迹。更令人不安的是，他刻意与所有生灵保持距离。\n但不必畏惧。在那可怖的黏液之下，仍跳动着你熟悉的心——它依旧为忠诚与正义而搏动。\n他一度背弃誓言，如今终于重拾信条。\n他将继续抗争：对抗体内回响的另一个声音，也对抗一切威胁他珍视之物的力量。"
        }
      },
      "wheels": {
        "wheel-0001": {
          "name": "慈悲的哺育",
          "description": "队伍唯一：手牌上限 +2，无法和其他命轮提供的手牌上限叠加。回合结束时获得等同于装备者 300% 银钥充能的银钥能量。每次释放钥令，所有唤醒体获得 6 点狂气，若当前界域为「血肉」，还会使胚胎融合 +25%。"
        },
        "wheel-0002": {
          "name": "神言石板",
          "description": "队伍唯一：装备者造成的护盾提高 15%，生命回复提高 15%。奇数回合结束时装备者暴击率 +6% ，获得 8 点狂气；偶数回合结束时装备者暴击伤害 +6%，获得 120 银钥能量。若当前界域为「血肉」，使猩红熔炉累积上限提高 40%。"
        },
        "wheel-0003": {
          "name": "冬夜追忆",
          "description": "队伍唯一：战斗开始时对前排敌人施加 2 层 易伤。回合开始时，处于 易伤状态的敌人失去等同于装备者攻击力 12% 的临时力量。若当前界域为「血肉」，装备者释放「狂气爆发」后，胚胎融合 +15%。"
        },
        "wheel-0004": {
          "name": "以蔷薇之名",
          "description": "队伍唯一：装备者每造成 1 次伤害，有 100% 几率使装备者获得 2% 临时暴击伤害。装备者释放狂气爆发后对随机敌人造成 3 次等同于装备者攻击力 30% 的主动伤害。若当前界域为「血肉」，装备者每吞噬一个胚胎，就使胚胎融合 +20%。"
        },
        "wheel-0005": {
          "name": "挣脱锁链之日",
          "description": "队伍唯一：装备者卡牌造成的基础伤害提高 40%。回合开始时，有 30% 的几率生成一张装备者的随机卡牌到手牌中，附加消耗。若当前界域为「血肉」，对装备者使用「胚胎」时，使装备者本回合下次打击卡造成伤害的暴击率 ＋35%。"
        },
        "wheel-0006": {
          "name": "沉入殷红",
          "description": "队伍唯一：装备者造成的基础伤害提高 40%。装备者释放狂气爆发前抽 1 张装备者的指令卡，临时手牌上限 +1。若当前界域为「血肉」，装备者触发吞噬时临时暴击伤害提高 40%，每回合最多生效 1 次。"
        },
        "wheel-0007": {
          "name": "苍白后裔",
          "description": "队伍唯一：装备者造成的护盾提高 10%。装备者的「防御」对生命最高敌人造成装备者防御力 24% 的中毒。若当前界域为「血肉」，施加中毒时胚胎融合增加 12%，该效果每回合最多触发 3 次。"
        },
        "wheel-0008": {
          "name": "血肉狂宴",
          "description": "队伍唯一：装备者的「狂气爆发」暴击率和暴击伤害提高 15%。装备者释放「狂气爆发」后，获得等同于装备者体质 6% 的力量。若本次狂气爆发触发了吞噬效果，额外获得 1 次力量。"
        },
        "wheel-0009": {
          "name": "饕餮寓言",
          "description": "队伍唯一：装备者生命回复效果提高 15%。回合开始时，获得等同于上回合损失生命 15% 的临时力量和护盾。"
        },
        "wheel-0010": {
          "name": "吞噬摇篮曲",
          "description": "队伍唯一：战斗开始后，获得等同于装备者防御力 50% 的反击。触发死亡抵抗触发后在本次调查中概率减半，获得的死亡抵抗减半。后，获得至多总计 2 层「摇篮」：全体友方造成的护盾和生命回复提高 30% ，回合结束时移除 1 层，若当前界域为「血肉」，触发死亡抵抗触发后在本次调查中概率减半，获得的死亡抵抗减半。后胚胎融合 +25%。"
        },
        "wheel-0011": {
          "name": "安息之吻",
          "description": "队伍唯一：装备者造成的基础伤害提高 25%。每造成 1 次击杀就使装备者本次探索内暴击率提高 2% 且狂气爆发造成的基础伤害提高 5%，至多叠加 10 次。若当前界域为「血肉」，对装备者直接使用「胚胎」时额外获得 30 点狂气， 3 回合冷却。"
        },
        "wheel-0012": {
          "name": "写实主义悖谬",
          "description": "队伍唯一：装备者造成的狂气和力量提高 12%。释放狂气爆发后本回合下次其他唤醒体狂气爆发最终伤害、护盾、生命回复提高 15%，若本次狂气爆发触发了吞噬，装备者获得 15 点狂气。"
        },
        "wheel-0013": {
          "name": "枉蹙眉",
          "description": "队伍唯一：装备者造成的固定中毒和触发中毒效果提高 30%，血肉界域自动回复的胚胎融合提高 30%。装备者每回合首次触发共振打出自身指令卡或回合结束后重置自身共振计数。时其他唤醒体获得 10 点狂气。"
        },
        "wheel-0014": {
          "name": "溯洄时计",
          "description": "队伍唯一：打出装备者的指令卡后，有 60% 的概率将其从弃牌堆重新加入手牌，该效果单个回合只生效 1 次。"
        },
        "wheel-0015": {
          "name": "超越死亡",
          "description": "队伍唯一：装备者指令卡造成的治疗提高 17%。装备者释放「狂气爆发」前，其他唤醒体获得 6 点狂气。若我方队伍处于 易伤 状态，效果翻倍。"
        },
        "wheel-0016": {
          "name": "坠入虚无的人偶",
          "description": "装备者造成的中毒、获得的狂气和生命回复各提高 10%。装备者释放狂气爆发后，获得等同于本次狂气爆发消耗狂气 20% 的狂气。（包括本命轮在内的狂气获取加成会影响该数值。）"
        },
        "wheel-0017": {
          "name": "骑士之心",
          "description": "队伍唯一：装备者的「狂气爆发」造成的护盾提高 25%。装备者释放「狂气爆发」后，获得等同于装备者防御力 25% 层数的临时 力量。若我方队伍处于 脆弱状态，效果翻倍。"
        },
        "wheel-0018": {
          "name": "星天之兽",
          "description": "队伍唯一：装备者「打击」和「狂气爆发」基础伤害提高 50%。装备者打出「打击」后，装备者获得 5% 临时暴击率，每回合最多 3 次，达到 3 次时获得 15% 临时暴击伤害。"
        },
        "wheel-0019": {
          "name": "好运时间",
          "description": "队伍唯一：战斗开始时，每拥有一个造物就使装备者指令卡暴击率提高 3%。装备者释放狂气爆发后投一颗 4 面骰子，装备者获得 6 倍骰子点数的狂气和临时暴击伤害，若其投出 4 或以上，其他唤醒体也获得一半。"
        },
        "wheel-0020": {
          "name": "畸体回噬",
          "description": "装备者的狂气爆发基础伤害提高 60%。探索开始时，装备者进入学者人格状态。装备者释放狂气爆发后在学者和小丑人格之间切换。学者人格：回合结束时，装备者获得 20 点狂气。小丑人格：回合结束时，装备者暴击率和暴击伤害 +7%。"
        },
        "wheel-0021": {
          "name": "记忆螺旋",
          "description": "队伍唯一：装备者造成的护盾提高 20%。回合开始时，保留 50% 剩余护盾，保留的护盾至多为 20% 最大生命护盾。"
        },
        "wheel-0022": {
          "name": "腐朽赠礼",
          "description": "队伍唯一：装备者造成的 中毒 提高 25%，装备者释放狂气爆发前，先对所有敌人施加等同于装备者攻击力 30% 的中毒。使用钥令后，装备者获得 8 点狂气。"
        },
        "wheel-0023": {
          "name": "欲海浮沉",
          "description": "队伍唯一：装备者造成的反击提高 25%。每受到 1 次攻击，就获得等同于装备者攻击力 8% 的临时力量。装备者使用狂气爆发后，获得等同于装备者攻击力 15% 的反击。"
        },
        "wheel-0024": {
          "name": "跨越疼痛",
          "description": "队伍唯一：装备者造成的中毒和护盾提高 15%。装备者的「打击」暴击率和暴击伤害提高 35%，并获得最大生命 5% 的护盾，护盾效果每回合最多生效1次。"
        },
        "wheel-0025": {
          "name": "坚韧意志",
          "description": "队伍唯一：装备者造成的基础伤害和护盾提高 15%。探索开始时将一张装备者的「打击」和「防御」加入牌库。装备者打出「防御」后，使装备者下一张「打击」暴击率与暴击伤害提高 15%，装备者打出「打击」后，使装备者下一张「防御」护盾提高 15%，可堆叠 3 次。"
        },
        "wheel-0026": {
          "name": "无声欢宴",
          "description": "队伍唯一：装备者造成的中毒提高 15%。装备者释放狂气爆发后，回复等同于装备者体质 20% 的生命，每剩余 1 点算力就额外回复装备者体质的 5% 的生命。"
        },
        "wheel-0027": {
          "name": "隐世的转轮",
          "description": "队伍唯一：银钥积攒上限提高100%。手牌上限 +2，无法和其他命轮提供的手牌上限叠加。装备者银钥充能提高 25%。装备者打出卡牌后，本回合装备者指令卡暴击率和暴击伤害、造成的护盾、狂气和力量提高 6%，至多叠加 5 层。"
        },
        "wheel-0028": {
          "name": "琥珀色的死亡",
          "description": "队伍唯一：装备者造成的基础伤害提高 35%，造成的力量提高 12%。打出装备者指令卡后获得装备者攻击力 20% 的临时力量，每回合最多触发 5 次。"
        },
        "wheel-0029": {
          "name": "狂戮至世界尽头",
          "description": "队伍唯一：装备者狂气爆发和追击基础伤害提高 60%。本回合打出任意唤醒体的「打击」后，装备者「打击」伤害临时提高装备者攻击力的 25%，每回合最多生效 8 次。"
        },
        "wheel-0030": {
          "name": "旋转，旋转",
          "description": "队伍唯一：装备者造成的主动伤害提高等同于装备者攻击力 20%。每打出或弃掉装备者的 1 张指令卡后，对随机敌人造成等同于装备者攻击力 12% 的中毒。超维回合结束后，有 100% 概率触发所有敌人一次中毒效果。"
        },
        "wheel-0031": {
          "name": "至为珍贵的藏品",
          "description": "队伍唯一：每有一个敌人死亡时获得 2 黑印。装备者击杀敌人后，本次关卡中装备者的暴击伤害永久提高 10%，至多叠加 5 层。装备者每次触发跃迁效果，使装备者本回合造成的最终伤害提高 5%，至多叠加 3 层。"
        },
        "wheel-0032": {
          "name": "被缚的歌谣",
          "description": "队伍唯一：探索开始时将一张「灵感」和装备者的「打击」加入牌库，装备者「打击」基础伤害提高 30%，打出后有 100% 概率抽 1 张牌。该效果每回合最多触发 1 次。若当前界域为「超维」并在超维回合中，「打击」将 1 张「灵感」置入手中，当回合最多触发 1 次。"
        },
        "wheel-0033": {
          "name": "女王的戒律",
          "description": "队伍唯一：装备者造成的反击提高 25%。装备者打出卡牌后获得等同于装备者防御力 8% 的反击，每回合最多触发 2 次。若其进入超维空间，装备者还会获得 12 点狂气。释放狂气爆发后，所有敌人失去等同于装备者防御力 15% 的临时力量。"
        },
        "wheel-0034": {
          "name": "无法完成的演算",
          "description": "队伍唯一：装备者产生的狂气提高 15%。装备者释放狂气爆发后，获得 200 点银钥能量。"
        },
        "wheel-0035": {
          "name": "诗笺的句尾",
          "description": "队伍唯一：装备者指令卡暴击率和暴击伤害、指令卡造成的护盾、生命回复、狂气和力量提高 20%。若当前界域为「超维」，释放「湮灭」后获得 200 点银钥能量。进入超维回合后，本回合下一个钥令释放 2 次。"
        },
        "wheel-0036": {
          "name": "迷失的道路",
          "description": "队伍唯一：装备者造成主动伤害后，有 30% 的概率抽 1 张装备者的指令卡并使其算力消耗降低 1。该效果每回合只生效 1 次。"
        },
        "wheel-0037": {
          "name": "核心熔解",
          "description": "队伍唯一：装备者的「打击」基础伤害提高 25%，「防御」基础护盾提高 25%。打出装备者「打击」时获得装备者攻击力 15% 的临时力量，打出装备者「防御」时获得装备者防御力 5% 的临时戒备。若当前界域为「超维」，进入超维回合时获得一次临时力量与临时戒备。"
        },
        "wheel-0038": {
          "name": "快乐魔法秀",
          "description": "队伍唯一：装备者释放狂气爆发后，获得 6 点狂气与 50 点银钥能量，每有 4 张手牌就重复 1 次。若当前界域为「超维」时，装备者的卡牌进入超维空间后，获得等同于装备者攻击力 12% 的临时力量，每回合最多触发 2 次。"
        },
        "wheel-0039": {
          "name": "不可承受的自由",
          "description": "队伍唯一：手牌上限 +2，无法和其他命轮提供的手牌上限叠加。装备者造成的护盾和基础伤害提高 15%，进入超维回合后获得 80 点狂气。释放「湮灭」后所有唤醒体临时暴击伤害 + 25%，3 回合冷却。"
        },
        "wheel-0040": {
          "name": "永恒安魂曲",
          "description": "探索开始时，将 1 张附加销毁的「银钥曦光」洗入抽牌堆。每次释放钥令后，装备者暴击伤害提高 5%。每次装备者造成主动伤害时，本回合暴击率提高 8%，并获得等同于装备者银钥充能 80% 的银钥能量，每回合最多生效 5 次。"
        },
        "wheel-0041": {
          "name": "隐没的痛楚",
          "description": "队伍唯一：装备者狂气爆发造成的基础伤害提高 50%，银钥充能提高 30%。进入超维回合后，所有唤醒体获得 20 点狂气。释放「湮灭」后，装备者获得 20 点狂气。"
        },
        "wheel-0042": {
          "name": "扭曲的骑士诗",
          "description": "队伍唯一：装备者造成的基础伤害与暴击伤害提高 35%。回合开始时和装备者释放狂气爆发后获得 1 层「心火」，装备者本回合打出指令卡时消耗 1 层使其最终伤害和护盾提高 15%。超维回合中改为获得「神焰」，效果翻倍。"
        },
        "wheel-0043": {
          "name": "搭档特训",
          "description": "队伍唯一：释放钥令后，装备者的暴击率临时提高 35%。"
        },
        "wheel-0044": {
          "name": "开学日",
          "description": "队伍唯一：「融痕」和「灰烬遗迹」刷新后使装备者获得 45 点狂气。"
        },
        "wheel-0045": {
          "name": "亲爱的圣诞老爹",
          "description": "队伍唯一：在「D-Mark」商店首次购买「祈愿」，或在灰烬遗迹首次购买折扣商品时，有 100% 概率不消耗黑印。每次探索仅触发 1 次。"
        },
        "wheel-0046": {
          "name": "倒数时刻",
          "description": "队伍唯一：探索开始后，将 1 张「倒数时刻：5」加入牌库：打出后抽 1 张牌，并将下一张「倒数时刻」洗入弃牌堆，消耗。「倒数时刻：0」：抽 3 张牌，获得 3 点算力，并有 100% 概率将「倒数时刻：5」洗入弃牌堆，保留，消耗。"
        },
        "wheel-0047": {
          "name": "豪赌的智慧",
          "description": "队伍唯一：探索开始后，将 1 张「豪赌的智慧」洗入抽牌堆。「豪赌的智慧」：消耗 1 算力。将手中所有指令卡随机洗入抽牌堆，洗入的指令卡在下次打出时有 25% 概率额外生效 1 次，并且每洗入 1 张指令卡就使所有唤醒体获得 2 点狂气。保留。消耗。固有。"
        },
        "wheel-0048": {
          "name": "未送出的花",
          "description": "队伍唯一：若装备者为唤醒体「拉蒙娜」，完成关卡时获得的同调率提高 50% 。"
        },
        "wheel-0049": {
          "name": "踏过泥泞的玫瑰",
          "description": "队伍唯一：若装备者为唤醒体「环行·拉蒙娜」，完成关卡时其他唤醒体获得的同调率提高 50% ，但自身不获得同调率。"
        },
        "wheel-0050": {
          "name": "神王的颂歌",
          "description": "队伍唯一：战斗开始时，装备者获得 40 狂气。每当其他唤醒体释放狂气爆发时，装备者获得 6 狂气。若当前界域为「深海」，装备者释放狂气爆发后，获得等同于攻击力 5% 的触腕伤害。"
        },
        "wheel-0051": {
          "name": "隐秘的诞生",
          "description": "队伍唯一：装备者造成的护盾提高 15%，并且造成护盾时，己方全员获得 8% 临时暴击率，每回合最多生效 2 次。若当前界域为「深海」，每当有 1 条触腕攻击时，装备者获得 1 点狂气，每回合最多获得 10点。"
        },
        "wheel-0052": {
          "name": "于暴雨之中",
          "description": "队伍唯一：装备者的「打击」有 100% 概率获得 1 算力并触发所有敌人 10% 的中毒，若当前界域为「深海」，触发该效果时使 1 条触腕攻击 1 次。该效果单个回合只生效 1 次。"
        },
        "wheel-0053": {
          "name": "伤痛之鳍",
          "description": "队伍唯一：装备者造成的护盾和生命回复提高，提高量为 4% 装备者的体质，装备者造成的反击提高 15%，打出「防御」时还会获得装备者防御力 20% 的反击。战斗开始后，获得等同于装备者体质 12% 的 力量。若当前界域为「深海」，额外获得等量的触腕伤害。"
        },
        "wheel-0054": {
          "name": "海之梦",
          "description": "队伍唯一：装备者打出卡牌后，装备者获得 1 点狂气。战斗开始时，获得等同于装备者攻击力 9% 的 力量，若当前界域为「深海」，额外获得 6% 的 触腕伤害，后续的每个回合开始后，获得等同于装备者攻击力 3% 的 力量，若当前界域为「深海」，额外获得 2% 的 触腕伤害。"
        },
        "wheel-0055": {
          "name": "巨人之刃",
          "description": "队伍唯一：装备者释放狂气爆发后，其本回合暴击伤害提高 60% ，手中所有装备者的卡牌都有 35% 概率本回合内算力消耗降低 1 点。"
        },
        "wheel-0056": {
          "name": "虔诚的伟力",
          "description": "队伍唯一：装备者获得的狂气提高 10%，造成的中毒提高 15%。装备者造成主动伤害后，所有唤醒体获得等同于装备者基础暴击伤害 20% 的临时暴击伤害。若界域包含「深海」，触腕上限 +1，并在战斗开始时生成 1 条触腕。"
        },
        "wheel-0057": {
          "name": "珊瑚女之死",
          "description": "队伍唯一：打出装备者的卡牌后，获得等同于装备者 12% 防御力的护盾，每有 1 条触腕就使护盾提高装备者防御力的 3%。该效果单个回合只生效 1 次。"
        },
        "wheel-0058": {
          "name": "引舵之帆",
          "description": "队伍唯一：装备者生命回复提高 10%。释放狂气爆发后，下回合开始时回复 10% 已损失生命。"
        },
        "wheel-0059": {
          "name": "圣火中的指引",
          "description": "队伍唯一：装备者通过狂气爆发获得的护盾提高 30%。装备者释放狂气爆发后，所有唤醒体获得 20% 临时暴击伤害，每有 1 条触腕额外提高 1%。每次探索首次触发死亡抵抗时，下回合开始时回复 25% 最大生命。"
        },
        "wheel-0060": {
          "name": "渺远的伊甸园",
          "description": "队伍唯一：战斗开始时获得等同于 25% 基础狂气的狂气。装备者狂气爆发最终伤害提高，其百分比为基础狂气的 20%。切换至「怒涛」姿态时，获得等同于当前界域精通 35% 的临时界域精通，3 回合冷却。"
        },
        "wheel-0061": {
          "name": "暴食",
          "description": "队伍唯一：普通战斗结束后，可以选择放弃刻印，生命上限提高 20%。该效果最多生效 2 次。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0062": {
          "name": "狂乱",
          "description": "队伍唯一：融痕造物栏变为 3 个，其中一个为诅咒造物，购买诅咒造物后获得 15 点黑印。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0063": {
          "name": "宠爱",
          "description": "队伍唯一：关卡开始后，所有唤醒体获得 20 点狂气。首领战开始后，抽 2 张牌。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0064": {
          "name": "涌现",
          "description": "队伍唯一：融痕刷新次数 ＋1 ，刷新价格减少 5 点黑印。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0065": {
          "name": "谵妄",
          "description": "队伍唯一：融痕中觉醒唤醒体的价格降低 15 点黑印。装备者的灵知觉醒重复打出灵知觉醒无法叠加生效。获得固有。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0066": {
          "name": "呢喃",
          "description": "队伍唯一：战斗结束后，狂气最低的唤醒体获得 50 点狂气。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0067": {
          "name": "希冀",
          "description": "队伍唯一：每走过一个新的格子，回复 5% 已损失血量。使用应急灵知体后，所有唤醒体的暴击率和暴击伤害提高 100%。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0068": {
          "name": "明悟",
          "description": "队伍唯一：关卡开始后，获得 1000 点银钥能量。首领战开始后，获得 2 点算力。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0069": {
          "name": "惩戒",
          "description": "队伍唯一：首领战开始后，消耗最多 50 黑印，每消耗 1 点黑印获得 5% 死亡抵抗触发后在本次调查中概率减半，获得的死亡抵抗减半。。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0070": {
          "name": "眷顾",
          "description": "队伍唯一：普通战斗结束后可选择的刻印数量变为 4 个，装备者卡牌的刻印有 30% 概率升级为高级刻印。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0071": {
          "name": "活性",
          "description": "队伍唯一：休息处额外提供一个选项：消除至多 3 张症状，获得 20 点黑印。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0072": {
          "name": "放逐",
          "description": "队伍唯一：融痕售卖卡牌处允许售卖症状卡，卖出症状卡后获得 25 点黑印。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0073": {
          "name": "吮吸",
          "description": "队伍唯一：休息处的回复量提高 40%，选择回复生命后，将 2 张「灵感」加入牌库。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0074": {
          "name": "熟成",
          "description": "队伍唯一：战斗结束后，获得 1000 点银钥能量。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0076": {
          "name": "洞悉",
          "description": "队伍唯一：探索中视野+1，地图视野全开后获得 30 点黑印。首领战开始时，虚弱和易伤所有敌人 1 回合。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0077": {
          "name": "职责所在",
          "description": "队伍唯一：装备者释放狂气爆发后，所有友方获得 5 狂气。"
        },
        "wheel-0078": {
          "name": "专注精神",
          "description": "队伍唯一：释放钥令后，装备者获得 15 狂气。"
        },
        "wheel-0079": {
          "name": "苦咒缚",
          "description": "队伍唯一：装备者造成的 中毒提高 12%。「打击」对目标敌人造成等同于攻击力 15% 的 中毒。该效果每回合最多生效 3 次。"
        },
        "wheel-0080": {
          "name": "切割与伤害",
          "description": "队伍唯一：装备者的「打击」使目标敌人失去等同于装备者攻击力 12% 的临时力量}。该效果个回合内最多触发3次。"
        },
        "wheel-0081": {
          "name": "伏于夜色",
          "description": "队伍唯一：装备者的反击提高 12%。「防御」获得等同于装备者防御力 30% 的临时反击；在首领战中，改为获得 3 倍临时反击。死亡抵抗触发后，对所有敌人触发 100% 反击。"
        },
        "wheel-0082": {
          "name": "冒险的行囊",
          "description": "队伍唯一：打出装备者的「防御」后，获得等同于装备者攻击力 18% 的临时力量。"
        },
        "wheel-0083": {
          "name": "死亡的剖析",
          "description": "队伍唯一：装备者击杀敌方后，获得 20 狂气，获得 1% 暴击伤害，整场探索有效。"
        },
        "wheel-0084": {
          "name": "致挚友",
          "description": "队伍唯一：装备者释放狂气爆发后，全体友方本回合暴击率提高 25%。"
        },
        "wheel-0085": {
          "name": "记忆症候",
          "description": "队伍唯一：打出一张症状卡后，装备者获得 12 狂气。该效果一个回合内最多触发 2 次。装备者打出 1 张指令卡后，获得 1 点狂气。"
        },
        "wheel-0086": {
          "name": "心之壁垒",
          "description": "队伍唯一：装备者释放狂气爆发后，获得等同于装备者防御力 25% 的护盾。"
        },
        "wheel-0087": {
          "name": "临界点",
          "description": "队伍唯一：装备者造成主动伤害后，暴击率提高 10%；造成暴击后，清空通过该效果获得的暴击率。"
        },
        "wheel-0088": {
          "name": "勋爵手杖",
          "description": "队伍唯一：装备者狂气爆发基础伤害提高 30%，护盾和生命回复提高 15%。"
        },
        "wheel-0089": {
          "name": "信息就是生命",
          "description": "队伍唯一：装备者指令卡基础伤害提高 30%，护盾和生命回复提高 15%。"
        },
        "wheel-0090": {
          "name": "聚首时刻",
          "description": "队伍唯一：每打出 1 张装备者的卡牌，就获得 50 银钥能量。该效果单个回合最多生效 3 次。"
        },
        "wheel-0091": {
          "name": "不存在之地",
          "description": "队伍唯一：探索开始时，将一张装备者的「防御」加入牌库，装备者「防御」护盾提高 40%。"
        },
        "wheel-0092": {
          "name": "遗忘之手",
          "description": "队伍唯一：探索开始时，将一张装备者的「打击」加入牌库，装备者「打击」基础伤害提高 40%。"
        },
        "wheel-0093": {
          "name": "35mm的魔法",
          "description": "队伍唯一：装备者造成的护盾和中毒提高 10%。每当触发死亡抵抗触发后在本次调查中概率减半，获得的死亡抵抗减半。，所有唤醒体获得 15% 临时暴击率和暴击伤害。"
        },
        "wheel-0094": {
          "name": "伊萨拉乌的目光",
          "description": "队伍唯一：装备者造成的护盾和反击提高 10%。每当受到攻击时，有 100% 概率使所有唤醒体获得 1 点狂气。"
        },
        "wheel-0095": {
          "name": "镜中人",
          "description": "队伍唯一：回合结束时，装备者获得 5 点狂气。受到主动伤害和触腕伤害时，下回合开始时获得等同于伤害 3% 的护盾。若当前界域为「血肉」，则改为获得等同于伤害 3% 的猩红熔炉。"
        },
        "wheel-0096": {
          "name": "银鳕鱼的决心",
          "description": "队伍唯一：探索开始后，装备者进入银鳕鱼人格状态。装备者释放狂气爆发后将在银鳕鱼人格和猫咪人格之间切换。银鳕鱼人格：装备者造成主动伤害后获得 40 点银钥能量。猫咪人格：装备者造成主动伤害后获得 4% 临时暴击伤害。两个效果共享每回合最多触发 5 次的限制。"
        },
        "wheel-0097": {
          "name": "待到雪山消融",
          "description": "队伍唯一：装备者造成的基础伤害提高 15%。战斗开始时，装备者获得 25 层「冰雪」，装备者打出卡牌后获得 2 点狂气并移除 1 层。「冰雪」被完全移除后，装备者获得 20% 暴击率。"
        },
        "wheel-0098": {
          "name": "深海的呼唤",
          "description": "队伍唯一：战斗开始后，获得装备者攻击力 8% 的力量，若当前界域为「深海」，还会提高装备者攻击力 8% 的触腕伤害。"
        },
        "wheel-0099": {
          "name": "灼热的吻别",
          "description": "队伍唯一：装备者释放狂气爆发后，获得等同于装备者攻击力 3% 的力量。若当前界域为「血肉」，释放狂气爆发后，胚胎融合 +10%。"
        },
        "wheel-0100": {
          "name": "往昔的花与诗",
          "description": "队伍唯一：战斗开始时抽 1 张装备者的指令卡，并有 100% 的几率使其算力消耗降低 1。每当触发死亡抵抗触发后在本次调查中概率减半，获得的死亡抵抗减半。，都会重复触发 1 次该效果。"
        },
        "wheel-0101": {
          "name": "百万蒙宠之眼",
          "description": "队伍唯一：装备者造成的伤害数值提高装备者攻击力的 12%。若当前界域为「血肉」，装备者每当触发了吞噬效果，额外使装备者造成的伤害数值提高装备者攻击力的 3%。"
        },
        "wheel-0102": {
          "name": "冰川下的沉眠",
          "description": "队伍唯一：装备者造成的护盾提高 10%。释放钥令后所有唤醒体获得 10% 临时暴击率和暴击伤害，但附加最大生命 3% 的献祭战斗结束时，剩余的献祭层数会继承至下一场战斗。。若当前界域为「深海」，释放钥令后还会使触腕伤害提高装备者攻击力的 3%。"
        },
        "wheel-0103": {
          "name": "命运轮盘赌",
          "description": "队伍唯一：装备者暴击率提高 8%.装备者击杀敌人后获得 6 点黑印，在探索中最多触发 3 次。触发 3 次后本次探索装备者永久提高 6% 暴击率。"
        },
        "wheel-0104": {
          "name": "真理之门",
          "description": "队伍唯一：战斗开始后，获得等同于装备者 500% 银钥充能的银钥能量。每场战斗首次释放钥令后，重复一次该效果。"
        },
        "wheel-0105": {
          "name": "永不停歇的演奏",
          "description": "队伍唯一：回合结束后，装备者获得 5 点狂气。装备者释放狂气爆发后，本回合打出的下一张装备者的指令卡暴击率、暴击伤害、护盾、回复生命提高 20%。"
        },
        "wheel-0106": {
          "name": "牧羊人的手杖",
          "description": "队伍唯一：战斗开始时，装备者获得等同于 100% 装备者狂气回充的狂气。装备者每场战斗首次释放狂气爆发后，重复一次该效果。"
        },
        "wheel-0107": {
          "name": "青石王座",
          "description": "队伍唯一：战斗开始时，赋予抽牌堆中装备者所有算力消耗大于 3 的指令卡「不朽支配」效果：此卡牌拥有保留，打出后所有唤醒体临时暴击率提高 10% 并移除「不朽支配」。若当前界域为「深海」，「不朽支配」移除后获得 1 点算力。"
        },
        "wheel-0109": {
          "name": "珍馐",
          "description": "队伍唯一：装备者造成的基础伤害提高 15%。若当前界域为「血肉」，装备者击杀敌方时积攒装备者攻击力 20%的猩红熔炉。"
        },
        "wheel-0110": {
          "name": "魔女宽檐帽",
          "description": "队伍唯一：装备者每回合使用的第一张指令卡造成的基础伤害提高 60%.若其进入了超维空间，装备者获得 8 点狂气。"
        },
        "wheel-0111": {
          "name": "蓝环毒素",
          "description": "队伍唯一：装备者银钥充能、狂气爆发造成的最终伤害、护盾提高 8%。"
        },
        "wheel-0112": {
          "name": "孤羽",
          "description": "队伍唯一：装备者造成的护盾提高 12%，回合结束时获得装备者防御力 10% 的护盾，每回合提高防御力的 2%。"
        },
        "wheel-0113": {
          "name": "圣子尊容",
          "description": "队伍唯一：超维回合装备者获得 3 层「心火」，装备者本回合打出指令卡时消耗 1 层，使其最终伤害和护盾提高 15%。"
        },
        "wheel-0114": {
          "name": "海上领航者",
          "description": "队伍唯一：战斗开始时，获得等同于装备者防御力 30% 的护盾。触发死亡抵抗触发后在本次调查中概率减半，获得的死亡抵抗减半。后，下回合开始时再次触发该效果。"
        },
        "wheel-0115": {
          "name": "渴求的画笔",
          "description": "队伍唯一：装备者释放狂气爆发后获得 1 层「共创」，本回合内下次其他唤醒体的狂气爆发能够消耗「共创」，使该次狂气爆发暴击率提高 25%，并使消耗「共创」的唤醒体获得装备者狂气回充 25% 的狂气。"
        },
        "wheel-0116": {
          "name": "迫近的太阳",
          "description": "队伍唯一：装备者造成的基础伤害提高 15%。打出 5 张装备者的指令卡后，装备者获得 20% 临时暴击率，该效果每回合只能触发 1 次。"
        },
        "wheel-0117": {
          "name": "理智明灯",
          "description": "队伍唯一：装备者每回合首次释放钥令后 100% 概率抽 1 张装备者的「打击」。"
        },
        "wheel-0118": {
          "name": "玉兰之饵",
          "description": "队伍唯一：装备者造成固定中毒和触发中毒效果提高 10%。装备者每回合首次触发共振打出自身指令卡或回合结束后重置自身共振计数。时获得 10 点狂气。"
        },
        "wheel-0119": {
          "name": "被囚禁的疯狂",
          "description": "队伍唯一：切换至「怒涛」姿态时，获得等同于当前界域精通 20% 的临时界域精通，3 回合冷却。"
        },
        "wheel-0120": {
          "name": "阿库特之春",
          "description": "队伍唯一：回合结束时装备者获得 15 点狂气，获得等同于装备者银钥充能的银钥能量。"
        },
        "wheel-0121": {
          "name": "陨日",
          "description": "队伍唯一：装备者造成的基础伤害、中毒和反击提高 20%，暴击率和暴击伤害提高 20%。"
        },
        "wheel-0122": {
          "name": "灵魂诞生",
          "description": "队伍唯一：队伍生命上限提高 10%。装备者造成的治疗和护盾提高 10%。打出装备者的「打击」后，回复 6% 已损失生命。打出装备者的「防御」后，获得 6% 当前生命的护盾。该效果每回合最多各触发 1 次。"
        },
        "wheel-0123": {
          "name": "极夜与破晓",
          "description": "队伍唯一：回合结束后获得 200 点银钥能量。触发死亡抵抗触发后在本次调查中概率减半，获得的死亡抵抗减半。后获得 1000 点银钥能量。使用应急灵知体后，算力上限提高 3，每回合抽牌数提高 3。"
        },
        "wheel-0124": {
          "name": "纯银的初心",
          "description": "队伍唯一：释放钥令后，获得装备者攻击力 3% 的力量和防御力 15% 的护盾。使用应急灵知体后，回合结束时所有唤醒体获得 30 点狂气。"
        },
        "wheel-0125": {
          "name": "重生于湮土",
          "description": "队伍唯一：装备者释放狂气爆发后，使狂气爆发基础伤害提高 10%，护盾和生命回复提高 5%，至多叠加 5 次。探索期间，装备者获得的同调率提高 25%。"
        },
        "wheel-0126": {
          "name": "你我终将重逢",
          "description": "队伍唯一：主动切换触腕姿态、使用猩红熔炉、释放「湮灭」后，抽 1 张装备者的指令卡，每个效果各 3 回合冷却。完成探索后所有唤醒体获得的同调率提高 10%。"
        },
        "wheel-0128": {
          "name": "永世编织之网",
          "description": "队伍唯一：装备者护盾提高 25%，装备者造成追击时 + 40% 临时强效，每回合最多生效 5 次。每当触发维度穿梭时，装备者获得 10 点狂气。"
        },
        "wheel-0130": {
          "name": "私密午歇时间",
          "description": "队伍唯一：探索开始后，将 1 张「私密午歇时间」洗入抽牌堆。「私密午歇时间」：消耗 1 算力。临时暴击伤害 + 80%。保留。消耗。"
        },
        "wheel-0131": {
          "name": "子宫之梦",
          "description": "手牌上限 +2，且不与其他命轮叠加。装备者狂气爆发造成的最终伤害、获得的护盾与银钥充能均提高 20%。切换至静海姿态时，装备者获得 30 点狂气，冷却 3 回合。切换至怒涛姿态时，使所有敌人获得 10 层诞生仪式，冷却 3 回合。"
        },
        "wheel-0132": {
          "name": "宿命纺轮",
          "description": "队伍唯一：装备者造成的护盾提高 10%，装备者造成追击时 + 15% 临时强效，每回合最多生效 5 次。"
        },
        "wheel-0136": {
          "name": "贪婪",
          "description": "队伍唯一：关卡开始后，获得 30 点黑印。造物上限+2。在星辰篇中，效果改为「使装备者的维度影像造物出现的可能性提高100%」。"
        },
        "wheel-0137": {
          "name": "催眠灵摆",
          "description": "队伍唯一：装备者银钥充能提高 10%。首场战斗开始后，对所有敌人施加 1 层虚弱和易伤。"
        },
        "wheel-0165": {
          "name": "樱花下的迷思",
          "description": "队伍唯一：探索开始后生成一张「春之信」置入牌库：1 算力，获得 250 银钥能量，打出后永久变化为「樱满开」。保留。「樱满开」：1 算力，获得 500 银钥能量，打出后永久变化为「花吹雪」。保留。「花吹雪」：1 算力，获得 750 银钥能量，打出后永久变化为「一期一会」。保留。「一期一会」：1 算力，从已解锁的 3 个随机钥令中选择 1 个立刻释放，并生效 2 次，打出后永久变化为「春之信」。保留。"
        },
        "wheel-0166": {
          "name": "致群星",
          "description": "队伍唯一：装备者自身、命轮、密契每有 1% 黑印掉落，结束战斗后回复 0.3% 最大生命，每回合结束就使该回复效果衰减 30%，多次独立计算。在「灰烬遗迹」中释放「感应」后，本次「灰烬遗迹」刷新无需消耗黑印。"
        },
        "wheel-0167": {
          "name": "愿世界化作芬芳",
          "description": "队伍唯一：算力上限 +1，无法和其他命轮提供的算力上限叠加。装备者每有 10 点基础狂气，造成的侵蚀提高 5%，造成的胚胎融合提高 1.5%。"
        },
        "wheel-0168": {
          "name": "淤泥里的童话",
          "description": "队伍唯一：使用「猩红熔炉」后装备者获得 10% 基础狂气，3 回合冷却。"
        },
        "wheel-0169": {
          "name": "伪北罗盘",
          "description": "队伍唯一：装备者的力量降低效果提高 15%。切换至怒涛姿态后，临时暴击伤害提高，数值等于装备者基础暴击伤害的 15%，冷却 3 回合。"
        },
        "wheel-0170": {
          "name": "梦游异世界",
          "description": "队伍唯一：探索开始后，将 1 张衍生牌「梦游异世界」加入牌组。消耗 2 点算力，使装备者获得 50 点狂气与 3 层精神干扰；保留，消耗。"
        },
        "wheel-0171": {
          "name": "活体牢笼",
          "description": "队伍唯一：装备者的力量降低效果提高 35%。本次探索中每击杀 1 个敌人，装备者回合结束时固定回复的狂气 +2，最多叠加 10 次。切换至怒涛姿态后，临时暴击伤害提高基础暴击伤害的 35%，冷却 3 回合。"
        },
        "wheel-0172": {
          "name": "鲸落",
          "description": "队伍唯一：装备者「打击」的暴击伤害提高 75%。回合结束时，使装备者下一次狂气爆发的暴击伤害提高，数值等同于其基础狂气的 20%，最多叠加 5 次。"
        },
        "wheel-0173": {
          "name": "不灭饥骨",
          "description": "队伍唯一：装备者「打击」的暴击伤害提高 50%。"
        },
        "wheel-0174": {
          "name": "向上坠落",
          "description": "队伍唯一：探索开始后，将 1 张衍生牌「尘世旅途」加入牌组。该牌消耗 0 点算力，对所有敌人造成等于装备者攻击力 3000% 与其生命上限 1% 的固定腐蚀伤害，使其他唤醒体的指令卡发生认知扭曲，并将 1 张「向上坠落」洗入抽牌堆；保留，消耗。"
        },
        "wheel-0175": {
          "name": "蜜果的谎言",
          "description": "队伍唯一：装备者的狂气爆发产生的基础护盾提高 40%。装备者打出施加弱化的指令卡后，下一张指令卡产生的基础护盾提高 40%。使用猩红熔炉时，抽取装备者算力消耗最高的技能卡，并使胚胎融合增加 40，冷却 3 回合。"
        },
        "wheel-0176": {
          "name": "恬美真相",
          "description": "队伍唯一：装备者打出施加弱化的指令卡后，下一张装备指令卡产生的基础护盾增加 40，无法叠加。"
        },
        "wheel-0177": {
          "name": "魂灵同调",
          "description": "队伍唯一：探索开始时，将 1 张「魂灵同调」加入牌库。「魂灵同调」（0 算力）：打出时获得 1 点算力。保留：此牌在手中时，每回合积攒固定生命回复（等同于装备者体魄的 6%）和 4 点固定狂气。装备者受到致命伤害时，此牌阻止其死亡，将积攒的生命与狂气全部释放给装备者，随后销毁。"
        },
        "wheel-0178": {
          "name": "向阳而生",
          "description": "队伍唯一：装备者的「狂气爆发」产生的基础护盾和固定力量提高 30%。装备者的「防御」产生的基础护盾提高 50%。装备者打出「防御」后，获得相当于其攻击力 5% 的力量。"
        },
        "wheel-0179": {
          "name": "往日如影随形",
          "description": "队伍唯一：装备者的「狂气爆发」产生的基础护盾和固定力量提高 15%。"
        },
        "wheel-0180": {
          "name": "从黑暗到黑暗",
          "description": "队伍唯一：调查开始时，将 1 张「坠入长夜」加入牌组。"
        }
      },
      "covenants": {
        "covenant-0001": {
          "name": "机械降神",
          "description": "3件套： 界域精通 +12 6件套： 每场战斗的首个回合获得 1 点算力，首领战中，每 4 回合额外获得 1 点算力。"
        },
        "covenant-0002": {
          "name": "再衍化",
          "description": "3件套： 狂气回充等级 +2.4 6件套： 队伍唯一。探索开始时，装备者获得 35 点狂气。装备者使用狂气爆发后，本场战斗中回合结束时获得 2 点狂气，该效果至多堆叠 3 次。"
        },
        "covenant-0003": {
          "name": "猩红之拥",
          "description": "3件套： 暴击率 +4.8% 6件套： 装备者造成伤害时获得 35 点银钥能量，若造成暴击伤害，改为获得 70 点银钥能量，每回合最多触发 3 次。"
        },
        "covenant-0004": {
          "name": "猩红之悸",
          "description": "3件套： 暴击伤害 +7.2% 6件套： 释放钥令后，装备者获得 30% 临时暴击率。"
        },
        "covenant-0005": {
          "name": "扭曲双子·黑",
          "description": "3件套： 暴击率 +4.8% 6件套： 奇数回合开始后，将一张附加虚无和消耗的装备者的「打击」加入手牌。"
        },
        "covenant-0006": {
          "name": "埋骨地絮语",
          "description": "3件套： 死亡抵抗 +16.8% 6件套： 关卡开始时死亡抵抗提高 25%。触发死亡抵抗后，装备者获得 50 点狂气。"
        },
        "covenant-0007": {
          "name": "扭曲双子·白",
          "description": "3件套： 死亡抵抗 +16.8% 6件套： 偶数回合开始后，将一张附加虚无和消耗的装备者的「防御」加入手牌。"
        },
        "covenant-0008": {
          "name": "诅咒兔",
          "description": "3件套： 界域精通 +12 6件套： 装备者造成的护盾与生命回复提高 12%。"
        },
        "covenant-0009": {
          "name": "二律背反",
          "description": "3件套： 银钥充能等级 +7.2 6件套： 队伍唯一。装备者的狂气上限及狂气爆发消耗狂气 +20，装备者指令卡的暴击率、暴击伤害、护盾、回复生命提高 20%。"
        },
        "covenant-0010": {
          "name": "光合祭礼",
          "description": "3件套： 伤害强效 +7.2% 6件套： 队伍唯一。装备者的指令卡进入超维空间后，胚胎融合 +25%~50%，当前生命越低则获得胚胎融合越高。"
        },
        "covenant-0011": {
          "name": "海归线",
          "description": "3件套：界域精通 +12。6件套：队伍唯一：战斗开始时，获得等同于装备者攻击力 12% 的力量。若当前界域为「深海」，效果改为：每回合开始时，有（50 + 0.25 × 队伍界域精通）% 的概率获得 1 层触腕集结；概率超过 100% 时可获得多层，在首领战中概率翻倍。"
        },
        "covenant-0012": {
          "name": "36室之环",
          "description": "3件套： 狂气回充等级 +2.4 6件套： 队伍唯一。银钥能量上限及钥令消耗银钥能量 +200，装备者狂气爆发的暴击率、暴击伤害、护盾、回复生命提高 30%。"
        },
        "covenant-0013": {
          "name": "生机榨取",
          "description": "3件套： 银钥充能等级 +7.2 6件套： 队伍唯一。回合结束时获得等同于装备者银钥充能 200% 的银钥能量。若当前界域为「血肉」，效果变为每有 5 点银钥充能，就使胚胎融合 +1%。"
        },
        "covenant-0014": {
          "name": "四月礼赞",
          "description": "3件套： 暴击伤害 +7.2% 6件套： 队伍唯一。回合开始时，若敌人总生命大于 75%，装备者临时暴击率和暴击伤害 +35%。"
        },
        "covenant-0015": {
          "name": "有机形态",
          "description": "3件套： 黑印掉落 +3.6% 6件套： 队伍唯一。探索开始时扣除至多 100% 死亡抵抗。每扣除 1% 死亡抵抗，就使装备者造成的狂气提高 0.15%。"
        },
        "covenant-0016": {
          "name": "甜蜜蛞蝓",
          "description": "3件套： 死亡抵抗 +25.2% 6件套： 队伍唯一。若在 1 回合内同时释放了「湮灭」并切换过触腕姿态，装备者本回合造成的护盾、生命回复、最终伤害 +25%，3回合冷却。"
        },
        "covenant-0017": {
          "name": "入药之梦",
          "description": "3件套： 伤害强效 +4.8% 6件套： 队伍唯一。战斗结束时获得的黑印 -8，战斗开始时将装备者非打击防御指令卡的原始复制洗入抽牌堆，每种至多 1 张。"
        },
        "covenant-0018": {
          "name": "远方的欢宴",
          "description": "3件套： 黑印掉落 +3.6% 6件套： 探索开始时，获得 10 黑印。「防御」造成护盾提高 30%。若装备者黑印掉落大于 15%，效果翻倍。"
        },
        "covenant-0019": {
          "name": "无垢启示录",
          "description": "3件套： 银钥充能等级 +7.2 6件套： 队伍唯一。释放钥令后，回复等同于装备者体质 12% 的生命，效果随损失生命比例提高，至多提高为装备者体质 24% 的生命。"
        },
        "covenant-0020": {
          "name": "荒原狼",
          "description": "3件套： 伤害强效 +4.8% 6件套： 装备者造成的基础伤害提高 20%，造成的中毒和反击提高 10%。"
        },
        "covenant-0021": {
          "name": "少女之蛹",
          "description": "3件套： 暴击率 +7.2% 6件套： 队伍唯一。装备者每回合首次消耗胚胎后，每拥有 1 条触腕获得 8% 临时暴击伤害，最大 80%。"
        }
      },
      "posses": {
        "posse-0001": {
          "name": "纯白初遇",
          "description": "弃掉所有手牌，抽取弃掉数量 +2 的牌。"
        },
        "posse-0002": {
          "name": "脑中之音",
          "description": "对所有敌人造成 1 回合虚弱和易伤，偷取 x 点临时力量。"
        },
        "posse-0003": {
          "name": "注射守护",
          "description": "获得 x 点护盾，当前生命若低于 25%，回复 x 点生命。"
        },
        "posse-0004": {
          "name": "鼠鼠的智慧",
          "description": "获得 3 点算力。"
        },
        "posse-0005": {
          "name": "小小心愿",
          "description": "选择 1 名唤醒体使其获得 35 点狂气。"
        },
        "posse-0006": {
          "name": "永世执念",
          "description": "获得 x点力量，额外获得等同于永久力量 25% 的临时力量。"
        },
        "posse-0007": {
          "name": "不平等交换",
          "description": "抽 4 张牌。"
        },
        "posse-0008": {
          "name": "不朽的葬仪",
          "description": "所有唤醒体获得 15 点狂气，下回合开始时，获得 5% 最大生命献祭战斗结束时，剩余的献祭层数会继承至下一场战斗。。"
        },
        "posse-0009": {
          "name": "最后的誓言",
          "description": "获得 25% 临时暴击率和 x 点临时力量。若在首领战中且本回合尚未打出过任何牌，则尝试触发 1 次死亡抵抗，若成功则获得 x 点护盾，此效果只能触发 1 次。"
        },
        "posse-0010": {
          "name": "奥瑞塔的宝藏",
          "description": "从抽牌堆中抽 3 张算力消耗最低的卡牌。若当前界域为「深海」，则额外使触腕伤害提高 x 点。"
        },
        "posse-0011": {
          "name": "咆哮的血与沙",
          "description": "选择 1 名唤醒体使其获得 20 点狂气，获得 x 点力量，若当前界域为「血肉」，额外使胚胎融合 +20，但失去 10% 当前生命。"
        },
        "posse-0012": {
          "name": "短暂的永恒",
          "description": "获得 1 点算力。选择 1 名唤醒体，将其 1 张「打击」与 1 张「防御」的原始复制置入手中，并使他们获得消耗，虚无。若当前界域为「超维」，则额外获得 x 点临时力量与 x 点临时戒备。"
        },
        "posse-0013": {
          "name": "腐烂盛筵",
          "description": "获得 Arg1 点反击，并使所有敌人暂时降低 Arg2 点力量。若当前处于「超维回合」，则不再降低力量，改为对所有敌人触发 100% 反击。数值随原初精通成长。"
        },
        "posse-0014": {
          "name": "蚀骨的拥抱",
          "description": "获得 1 点算力，下回合开始时获得 x 点护盾。若当前界域为「深海」且处于「潮涌」姿态，则效果变为生成 1 条触腕。"
        },
        "posse-0015": {
          "name": "湖畔回眸",
          "description": "对生命最高敌人造成 x 点中毒，获得 x 点护盾。若本回合触发过吞噬，不再获得护盾，触发该敌人一半的中毒。"
        },
        "posse-0016": {
          "name": "跨越回溯之扉",
          "description": "从抽牌堆中选择 1 张牌加入手中，并使其算力消耗降低 1。"
        },
        "posse-0017": {
          "name": "灰雾真容",
          "description": "获得 x 点力量，将 1 张「灵感保留。消耗。」置入手中。若当前为超维回合，效果变更为将 2 张「灵感保留。消耗。」置入手中。"
        },
        "posse-0018": {
          "name": "仲夏之梦",
          "description": "抽 1 张牌，如果抽到「指令卡」或「灵知觉醒」，将其算力消耗变为 0，并使其拥有者获得 20 点狂气。否则将这张牌弃掉并重复此条效果。"
        },
        "posse-0019": {
          "name": "玫瑰的胜利",
          "description": "获得 x 点临时力量，抽 2 张牌。若当前界域为「血肉」，损失 10% 当前生命，额外获得 x 点临时力量，手中每有 1 张胚胎打出后选择一名唤醒体获得 30 点狂气，本回合暴击率提高 10%。保留。消耗。额外获得 x 点临时力量。"
        },
        "posse-0020": {
          "name": "神迹降临",
          "description": "获得 x 点力量。受到攻击伤害时，下回合开始时获得 10% 伤害的护盾。若当前界域为「血肉」，不再获得延迟护盾，而是积攒 10% 伤害的回复量到猩红熔炉。"
        },
        "posse-0021": {
          "name": "巨人的霸道",
          "description": "获得 1 点算力和 x 点力量，选择一名唤醒体获得 15 点狂气。若当前界域为「深海」且处于「怒涛」姿态，效果改为获得 15% 临时暴击率和临时暴击伤害。"
        },
        "posse-0022": {
          "name": "全部的她",
          "description": "界域精通提高 24。选择 1 名唤醒体使其获得 24 点狂气。"
        },
        "posse-0023": {
          "name": "唯一的种子",
          "description": "选择 1 张手中的非衍生指令卡，获得一张附加消耗的原始复制，并使指令卡的所有者获得 15 点狂气。"
        },
        "posse-0024": {
          "name": "群山的觉悟",
          "description": "选择一名唤醒体，抽 2 张该唤醒体的指令卡。"
        },
        "posse-0025": {
          "name": "海之祭",
          "description": "抽 2 张牌，获得 2 点算力，所有唤醒体失去 5 点狂气。若当前处于「静海」姿态，对所有敌人施加 x 层中毒，在首领战中发挥 3 倍效果。"
        },
        "posse-0026": {
          "name": "春天的献诗",
          "description": "从四种诗页风颂歌：获得 x 点力量。花颂：所有唤醒体获得 10 点狂气。月颂：临时暴击率提高 30%。中选择一项，并将其从选项中移除。所有诗页都被选择后，重置。"
        },
        "posse-0027": {
          "name": "一声枪响",
          "description": "将 1 枚置入手中，获得 15% 临时暴击率。「闪耀偏方骰子」：投一颗 6 面骰子，获得等同于骰子点数 *13 的临时力量，若点数为 4 或更高，虚弱和易伤所有敌人 1 回合。若点数为 6 或更高，则获得临时力量翻倍并获得 1 点算力。消耗。保留。"
        },
        "posse-0028": {
          "name": "第四乐章",
          "description": "本回合下一张打出的卡牌若算力消耗大于等于 3，获得 2 点算力，否则抽 2 张牌。若为本场战斗中第 4 次生效，改为直接获得 4 张「灵感保留。消耗。」。"
        },
        "posse-0029": {
          "name": "门扉的答案",
          "description": "发现 3 个随机的钥令，选择其中 1 个触发其效果并获得 200 点银钥能量。"
        },
        "posse-0030": {
          "name": "虚无瘟疫",
          "description": "选择一名唤醒体获得 20 点狂气，对所有敌人施加 x 层中毒，目标每损失 1% 生命额外触发 1% 中毒，至多触发 50% 中毒。"
        },
        "posse-0031": {
          "name": "群星的庇佑",
          "description": "选择「沉眠」或「苏醒」。沉眠：获得 x 点护盾，获得 1 层「星辰庇佑」，最大积攒 5 层，战斗结束后不清除。苏醒：所有唤醒体获得 8 点狂气，消耗所有「星辰庇佑」并获得与消耗层数相同的算力，若当前界域为「深海」，额外生成与消耗层数相同的临时触腕。"
        },
        "posse-0032": {
          "name": "黑天鹅的舞步",
          "description": "选择一名唤醒体，使其指令卡暴击率和暴击伤害临时提高 15% 并获得 15 点狂气。若「莉兹」在队伍中，还会将 1 张附加消耗的「腐化绿炎」置入手中。"
        },
        "posse-0033": {
          "name": "酒馆之门",
          "description": "将 1 张「莉雅的硬币」置入弃牌堆。「莉雅的硬币」：获得 2 点算力，抽 2 张牌。消耗。保留。"
        },
        "posse-0034": {
          "name": "特殊治疗",
          "description": "回复 x 点生命，获得 x 点力量。若克莱门汀在队伍中，使她本回合下次打出的指令卡伤害、护盾、生命回复、获得狂气、获得银钥能量的效果次数提高 1。"
        },
        "posse-0035": {
          "name": "不灭的雷光",
          "description": "获得 x 点护盾，抽 2 张牌。若「克珀珊特」在队伍中，还会将 1 张「领航」置入手中。"
        },
        "posse-0036": {
          "name": "错位命运",
          "description": "选择一名唤醒体使其获得 15 点狂气，从抽牌堆中抽 2 张算力消耗最低的卡牌。若「卡斯托尔」在队伍中，使其伤害强效临时提高 30%。"
        },
        "posse-0037": {
          "name": "残忍的致意",
          "description": "偷取所有敌人 x 点临时力量。若「杜勒赛因」在队伍中，获得 1 个残骸残骸会继承至下场战斗。。"
        },
        "posse-0038": {
          "name": "不落的太阳",
          "description": "获得 1 点算力和 30% 临时强效。若「凯蒂古拉」在队伍中，抽 1 张其「指令卡」并赋予 1 层「活焰拥有「活焰」的卡牌获得「保留」，打出后消耗所有「活焰」并将 1 层「活焰」传导到手中其它 1 张凯蒂古拉的指令卡上。」。"
        },
        "posse-0039": {
          "name": "泣血的圣心",
          "description": "抽 1 张牌并使其算力消耗 -1，若抽到指令卡则使其拥有者获得 25% 临时暴击伤害。若「波吕克斯」在队伍中，获得 5 层罪印。"
        },
        "posse-0040": {
          "name": "猎食决心",
          "description": "从出战唤醒体的技能卡中发现 3 张，选择 1 张将其临时复制置入手中，并使其算力消耗降低 1。若当前界域为「血肉」，可以选择「一扫而光！」。"
        },
        "posse-0041": {
          "name": "定格的仲夏留念",
          "description": "选择 1 名唤醒体，将 1 张算力消耗为 0 的临时「打击」置入手中。每第 3 次释放，改为将 1 张「美丽瞬间」置入手中，并使所有唤醒体临时暴击率提供 20%。"
        },
        "posse-0042": {
          "name": "虚世之彩",
          "description": "选择一名唤醒体获得 20 点狂气，将 1 张「灵感保留。消耗。」洗入抽牌堆。若「皮克曼」在队伍中，使其获得 1 层创意创意上限为 10 层，能够继承至下场战斗。。"
        },
        "posse-0043": {
          "name": "美梦一刹",
          "description": "获得 x 点护盾和等同于当前护盾 10% 的临时力量。"
        },
        "posse-0044": {
          "name": "偏航船",
          "description": "获得 1 点算力，所有敌人施加 5 层降生仪式。若「诞妄·墨菲」在队伍中，抽 1 张「螺湮圆舞」。"
        },
        "posse-0045": {
          "name": "重逢心愿",
          "description": "从弃牌堆中选择 1 张指令卡移回手中。若「拉蒙娜」在队伍中，使其本回合打出的下一张指令卡生效 2 次。"
        },
        "posse-0046": {
          "name": "来自雾境",
          "description": "抽 2 张「打击」，若「茉夏」在队伍中，使它们算力消耗 -1。"
        },
        "posse-0047": {
          "name": "深宅往事",
          "description": "获得 1 点算力并临时降低所有敌人 x 点力量。若「徐」在队伍中，对所有敌人施加 1 层痴醉。"
        },
        "posse-0048": {
          "name": "岁末花火",
          "description": "临时暴击率 +15%，获得 1 点算力。本场战斗首次释放时对所有敌人造成 x 点旧日余烬「旧日余烬」层数每回合重置。。"
        },
        "posse-0049": {
          "name": "溺亡的纯真",
          "description": "选择一名唤醒体获得 Arg1 点狂气，其他唤醒体获得 Arg2 点狂气。若「涡流」在队伍中，她会释放追击「涡！流！弹！」。数值随原初精通成长。"
        },
        "posse-0050": {
          "name": "罗网轮转",
          "description": "获得 x 点护盾和 50% 临时伤害强效。若「阿拉克涅」在队伍中，抽 1 张「永恒织造」并使其算力消耗 -1。"
        },
        "posse-0051": {
          "name": "献给新世界",
          "description": "获得 x 点护盾，抽 2 张「技能」并赋予其认知错乱打出或弃置后移除该状态。。若「沙耶」在队伍中，获得 1 层羽种该状态至多积攒 4 层，战斗结束后会保留。。"
        },
        "posse-0052": {
          "name": "空壳之人",
          "description": "临时暴击伤害 +Arg1，并使所有敌人的力量降低效果临时减少 Arg2。若蓬托斯在队伍中，获得 1 层群猎。数值随原初精通成长。"
        },
        "posse-0053": {
          "name": "噬鲸风暴",
          "description": "获得 Arg2 点力量。选择 1 名唤醒体，从其他唤醒体处偷取最多 10 点狂气。若鲸皇·萝坦在队伍中，其下一次「打击」额外生效 1 次。数值随原初精通成长。"
        },
        "posse-0054": {
          "name": "原初记忆·汲取",
          "description": "使所有敌人的力量降低效果临时减少 Arg1。数值随原初精通成长。"
        },
        "posse-0055": {
          "name": "原初记忆·催化",
          "description": "所有唤醒体获得 Arg1 点狂气。数值随原初精通成长。"
        },
        "posse-0056": {
          "name": "原初记忆·治愈",
          "description": "回复 Arg1 点生命。数值随原初精通成长。"
        },
        "posse-0057": {
          "name": "原初记忆·毒素",
          "description": "使所有敌人获得 Arg1 层中毒。数值随原初精通成长。"
        },
        "posse-0058": {
          "name": "原初记忆·尖刺",
          "description": "获得 Arg1 层临时反击。数值随原初精通成长。"
        },
        "posse-0059": {
          "name": "原初记忆·力量",
          "description": "获得 Arg1 点力量。数值随原初精通成长。"
        },
        "posse-0060": {
          "name": "原初记忆·壁垒",
          "description": "获得 Arg1 点护盾。数值随原初精通成长。"
        },
        "posse-0061": {
          "name": "原初记忆·狂怒",
          "description": "获得 Arg1 点临时伤害强效。数值随原初精通成长。"
        },
        "posse-0062": {
          "name": "绝非谎言之物",
          "description": "获得 Arg1 点护盾，并使界域精通提高 Arg2。若「卡拉布」在队伍中，下一次「卡拉布的祝福」不会附带代价。数值随原初精通成长。"
        },
        "posse-0063": {
          "name": "永续新篇",
          "description": "获得 Arg1 点护盾和 Arg2 点力量。若「负誓·奥吉尔」在队伍中，则其获得 Arg3 点狂气和 1 层「暗涌」。数值随原初精通成长。"
        }
      }
    }
  }
}
